// Metodo creada unicamente para el delete.
// Recibe un props que contiene el modelo y los datos
//
// retorna el json parametros con params armado.

/**
 * NOTE: Servicio para eliminar datos en el servidor
 * 
 * Fue modificado para que en el caso de que se le necesite pasar un array con varios objetos pueda modificarlo y metener un name para cada objeto
 */

export const paramsDelete = (params) => {
  let model = [];

  if(Object.entries(params.attributes).length > 0){

    const modelPost= {'model':[{'@name':params.model,'attributes':params.attributes}]}
    return modelPost;

  }else{
    params.attributes.forEach((element) => {
      model.push({ "@name": params.model, attributes: element });
    });
    const modelPost = {
      model: model,
    };
  
    return modelPost;
  }

  
};

export default paramsDelete;
